import React from "react";
import { RIGHTARROW } from "../../utils/app-image-contant";

const Button = ({
  buttonType = "button",
  buttonName = "Click",
  buttonStyle = "gradient-bg text-light",
  handleClick = function o() { },
  isArrow = false,
  buttonDisabled = false,
  ButtonIcon = "",
  isIcon = false,
  loader = false
}) => {

  return (
    <button
      type={buttonType}
      className={`common-btn-style ${buttonStyle}`}
      onClick={(e) => handleClick(e)}
      disabled={buttonDisabled || loader}
    >
      {loader && (<span className="spinner-border spinner-border-sm mx-1" name="spinner" role="status" aria-hidden="true"></span>)}
      {buttonName}{isArrow && <img src={RIGHTARROW} alt="right-arrow" className="ms-2" width="14px" />}
      {isIcon && <img src={ButtonIcon} alt="right-arrow" className="ms-2" width="14px" />}
    </button>


  );
};

export default Button;
